// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__1Ldwu","discard":"styles_discard__u3Ucd"};